import { render, staticRenderFns } from "./CusButton.vue?vue&type=template&id=4e2f6b2d&scoped=true&"
import script from "./CusButton.vue?vue&type=script&lang=js&"
export * from "./CusButton.vue?vue&type=script&lang=js&"
import style0 from "./CusButton.vue?vue&type=style&index=0&id=4e2f6b2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2f6b2d",
  null
  
)

export default component.exports